// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_7Nv","cls2":"SimplePaperPodcast-cls2_uBO SimplePaperPodcast-cls1_7Nv"};